import axios from '@p/utils/request';
import api from '@/api';
import loginAxios from 'axios'
import config from '@/config'

export const login = ({ username, password }) => {
	let data = `grant_type=password&username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}`
	return loginAxios.request({
		url: config.authUrl,
		data,
		headers: {
			Authorization: config.authCode
		},
		method: 'post'
	})
}

// 最新推荐课程
export const getHotCourse = (data) => {
	return axios.get(api.home.getHotCourse,data)
}

// 最新公开培训课
export const getPublicCourse = (data) => {
	return axios.get(api.home.getPublicCourse,data)
}

// 全部课程
export const getCourseAll = (data) => {
	return axios.get(api.home.getCourseAll,{params:data})
}

// 课程搜索
export const getCourseSearch = (data) => {
	return axios.get(api.home.getCourseSearch,{params:data})
}

// 获取所有课程分类
export const getAllCourseClass = (data) => {
	return axios.get(api.home.getAllCourseClass,{params:data})
}

// 根据用户所属部门获取课程
export const getDepartmentCourse = (data) => {
	return axios.get(api.home.getDepartmentCourse,{params:data})
}